import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Fab,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNotices } from '../../actions';
import { Content } from '../layout';
import { pageLimit as limit } from '../../config/keys';
import Pagination from '../common/Pagination';
import { targets } from './types';
import { fabStyle } from '../common/style';

const NoticeList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [page, setPage] = useState(0);

  const { count, rows } = useSelector((state) => state.notice.notices);

  useEffect(() => {
    dispatch(fetchNotices(page, limit));
  }, [dispatch, page]);

  const navigateToNoticeDetail = (id) => {
    navigate(`/notices/${id}/update`, { state: { id } });
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const renderNotices = () =>
    rows.map((notice) => (
      <TableRow
        key={notice.id}
        onClick={() => navigateToNoticeDetail(notice.id)}
        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
      >
        <TableCell>
          {
            targets.find(
              (target) => String(target.id) === String(notice.target)
            ).name
          }
        </TableCell>
        <TableCell>{notice.isUrgent === true ? '긴급' : '일반'}</TableCell>
        <TableCell>{notice.NoticeMacro.subject}</TableCell>
        <TableCell>{new Date(notice.createdAt).toLocaleString()}</TableCell>
      </TableRow>
    ));

  return (
    <Content>
      <Card>
        <CardContent>
          <Typography variant="h5" component="div">
            공지사항
          </Typography>
          <p />

          <TableContainer component={Paper}>
            <Table
              aria-label="notice-list table"
              sx={{ minWidth: 650, borderRight: 0 }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>구분</TableCell>
                  <TableCell>긴급</TableCell>
                  <TableCell>제목</TableCell>
                  <TableCell>등록일시</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{renderNotices()}</TableBody>
            </Table>
          </TableContainer>
          {/* <Pagination updatePage={updatePage} total={count} page={page} /> */}
          <TablePagination
            component="div"
            count={count}
            page={page}
            rowsPerPage={limit}
            onPageChange={handlePageChange}
          />
        </CardContent>
      </Card>
      <Fab
        sx={fabStyle}
        aria-label="add"
        color="primary"
        component={Link}
        to="notices/new"
      >
        <AddIcon />
      </Fab>
    </Content>
  );
};

export default NoticeList;
